import React from 'react';
import { Switch, Route, HashRouter as Router, Redirect } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { SnackbarProvider } from 'notistack';

import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';

import store from './store';
import theme from './theme';

import LoginPage from './features/auth/LoginPage';
import ForgotPasswordPage from './features/auth/ForgotPasswordPage';
import ResetPasswordPage from './features/auth/ResetPasswordPage';
import NotFound from './features/404';
import PIH from './PIH';
import StyleGuide from './features/StyleGuide';
import Notifier from './features/snackbar/Notifier';

import { initApp, selectAppStatus } from './features/app/appSlice';

import PrivateRoute from './features/PrivateRoute';
import LoadingPage from './features/app/LoadingPage';

// Check auth, fetch initial data etc.
store.dispatch(initApp());

const App = () => {
  const initialised = useSelector(selectAppStatus);

  if(!initialised) {
    return <LoadingPage />;
  }

  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/pih" />
        </Route>
        <Route path="/login">
          <LoginPage />
        </Route>
        <Route path="/forgot-password">
          <ForgotPasswordPage />
        </Route>
        <Route path="/reset-password/:token">
          <ResetPasswordPage />
        </Route>
        <PrivateRoute path="/pih">
          <PIH />
        </PrivateRoute>
        <Route path="/styleguide">
          <StyleGuide />
        </Route>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

function AppContainer() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <CssBaseline />
          <Notifier />
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default AppContainer;
